import React, { useState } from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import { graphql, Link, useStaticQuery } from 'gatsby';
import './Events.scss'
import moment from 'moment';
import axios from 'axios';
import EventbritePopupCheckout from '../EventBrite';
import $ from "jquery";
import ImageTransform from '../common/ggfx-client/module/components/image-transform';
import BookYourTicket from "../EventBanner/BookYourTicket";
import EventsDates from './EventsDates';

const limit = 9;

const Events = (props) => {
    const [events, setEvents] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const loadMore = async () => {
        setPage(page+1);
        let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${page*limit}&_limit=${limit}&_sort=Date:ASC&_where[Date_gt]=${moment().utc().format()}`;
        // let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${page*limit}&_limit=${limit}&_sort=Date:DESC`;
        let pastEventUrl = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_sort=Date:DESC&_where[Date_lt]=${moment().utc().format()}`;
        try {
            let eventsList = await axios.get(url, { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT } });
            if (eventsList?.data.length < 9 && eventsList?.data.length > 0) {
                let pastEventsList = await axios.get(pastEventUrl, { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT } });
                setEvents(prevEvents => [...prevEvents, ...eventsList.data, ...pastEventsList.data]);
            } else {
                setEvents(prevEvents => [...prevEvents, ...eventsList.data]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    React.useEffect(async () => {
        let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_sort=Date:ASC&_where[Date_gt]=${moment().utc().format()}`;
        // let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_sort=Date:DESC`;
        let countUrl = process.env.GATSBY_STRAPI_SRC + `/events/count?_where[Date_gt]=${moment().utc().format()}`;
        try {
            let eventsList = await axios.get(url,  { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }})
            let eventsCount = await axios.get(countUrl,  { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }})
            setEvents(eventsList.data);
            setCount(eventsCount.data);
        } catch (error) {
            console.log(error)
        }
        $('html, body').animate({
            scrollTop: 0
        }, 0)
    },[]);

    React.useEffect(async() => {
        if(props?.location?.search?.startsWith("?q=")) {
            setPage(1);
            let string = props?.location?.search?.split("?q=")[1];
            if(string) {
                // let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_where[Title_contains]=${string}&_sort=Date:ASC&_where[Date_gt]=${moment().utc().format()}`;
                let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_where[Title_contains]=${string}&_sort=Date:ASC`;
                let countUrl = process.env.GATSBY_STRAPI_SRC + `/events/count?_where[Title_contains]=${string}&_where[Date_gt]=${moment().utc().format()}`;
                // let countUrl = process.env.GATSBY_STRAPI_SRC + `/events/count?_where[Title_contains]=${string}`;
                try {
                    let eventsList = await axios.get(url,  { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }});
                    let eventsCount = await axios.get(countUrl,  { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }})
                    setEvents(eventsList.data);
                    setCount(eventsCount.data);
                } catch (error) {
                    console.log(error)
                }
            } else {
                // let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_sort=Date:ASC&_where[Date_gt]=${moment().utc().format()}`;
                let url = process.env.GATSBY_STRAPI_SRC + `/events?_start=${0}&_limit=${limit}&_sort=Date:ASC&_where[Date_gt]=${moment().utc().format()}`;
                // let countUrl = process.env.GATSBY_STRAPI_SRC + `/events/count?_where[Date_gt]=${moment().utc().format()}`;
                let countUrl = process.env.GATSBY_STRAPI_SRC + `/events/count`;
                try {
                    let eventsList = await axios.get(url,  { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }})
                    let eventsCount = await axios.get(countUrl,  { headers: { Authorization: "Bearer " + process.env.GATSBY_STRAPI_AT }})
                    setEvents(eventsList.data);
                    setCount(eventsCount.data);
                } catch (error) {
                    console.log(error)
                }
            }
        }
    }, [props?.location?.search])

    const ImageRenderList = ({item, imagename, id}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.Tile_Image_Transforms) {
            processedImages = item.imagetransforms.Tile_Image_Transforms;
        }
        return (
            <ImageTransform
                imagesources={item?.Tile_Image?.url}
                renderer="srcSet" imagename={imagename}
                attr={{ alt: item?.Tile_Image?.alternativeText ? item?.Tile_Image?.alternativeText : item?.Title+" - tlc Estate Agents", className: 'm-0' }}
                imagetransformresult={processedImages}
                lazyLoading={false}
                id={id}
            />
        )
    }

	return (
		<section className="events" id="events">
			<Container>
				<Row>
					<Col>
						<div className="events-block">
							{events?.map((item, index) => {
								return (
                                    <div className="event-wrap" key={index}>
                                        <div className="img-wrap img-zoom">
                                            {/* <img src={item.Tile_Image.url} alt={item.Tile_Image.alternativeText} /> */}
                                            <Link to={props.path+item.Url+"/"}>
                                                <ImageRenderList item={item} imagename={"events.Tile_Image.banner"} id={item?._id}/>
                                            </Link>
                                        </div>
                                        <div className="event-info">
                                            <h2><Link to={props.path+item.Url+"/"}>{item.Title}</Link></h2>
                                            <div className="event-cta">
                                                <EventsDates data={item} from_date={item.From} to_date={item.To} event_date={item.Date}/>
                                                <div className="book-ticket">
                                                    <EventbritePopupCheckout ebEventId={item.EventId} className={moment().isAfter(item.Date) ? "d-flex" : "cursor-pointer d-flex"} disabled={moment().isAfter(item.Date) || !item.EventId} event_item={item}>
                                                        <div className="wrap-icon">
                                                            <i className="icon-ticket"></i>
                                                        </div>
                                                        Book Tickets
                                                    </EventbritePopupCheckout>
                                                    {/* {
                                                        (moment().isAfter(item.Date) ?
                                                            <button type="button" className="btn_link" disabled={true}>
                                                                <div className="wrap-icon">
                                                                    <i className="icon-ticket"></i>
                                                                </div>
                                                                Book Ticket
                                                            </button>
                                                        :
                                                            <BookYourTicket data={item} className="btn_link" btnLabel="Book Ticket">
                                                                <div className="wrap-icon">
                                                                    <i className="icon-ticket"></i>
                                                                </div>
                                                            </BookYourTicket>
                                                        )
                                                    } */}
                                                </div>
                                                <div className="view-detail">
                                                    <Link to={props.path+item.Url}>
                                                        <div className="wrap-icon">
                                                            <i className="icon-lines"></i>
                                                        </div>
                                                        <span className="md">Details</span>
                                                        <span className='dd'>View Details</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
							    )}
                            )}
						</div>
						{(count !== (events.length)) && <div className="btn-wrap">
							<button type='button' className='btn' onClick={loadMore}>load more</button>
						</div>}
					</Col>
				</Row>
			</Container>
		</section>
	)
}

export default Events
